// Esempio di implementazione dei metodi per effettuare richieste HTTP al backend
import axios from "axios";
import { API_ENDPOINT } from "../config";
import { handleError } from "../libs/apiUtils";

export const getAudioList = async () => {
  try {
    const response = await axios.get(`${API_ENDPOINT}/audio/list`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const uploadFile = async (groupName, fileName, file) => {
  const formData = new FormData();
  formData.append("audio", file);
  formData.append("groupName", groupName);
  formData.append("fileName", fileName);

  try {
    const response = await axios.post(
      `${API_ENDPOINT}/audio/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

export const renameGroup = async (oldGroupName, newGroupName) => {
  try {
    const response = await axios.post(
      `${API_ENDPOINT}/audio/rename-group`,
      {
        oldGroupName,
        newGroupName,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export const renameFileTitle = async (fileId, newFileTitle) => {
  try {
    const response = await axios.post(
      `${API_ENDPOINT}/audio/rename-file-title`,
      {
        fileId,
        newFileTitle,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export const resetAudioDatabase = async () => {
  try {
    const response = await axios.post(
      `${API_ENDPOINT}/audio/reset-database`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};
